/**
 * Availability status values for products.
 *
 * Represents the current sales state of a product.
 * Values are string-based for readability in API responses, CRM mappings, and debug output.
 *
 * - AVAILABLE: product is on offer and can be purchased
 * - RESERVED:  product is reserved (pre-sale agreement signed)
 * - SOLD:      product has been sold (final agreement signed)
 * - HOLD:      product is temporarily unavailable — used by some CRMs to indicate
 *              a non-standard state that also implies hiding from public view
 * - UNKNOWN:   availability data is missing or could not be resolved (e.g. no CRM connection)
 */
export const AVAILABILITY_STATUS = {
  AVAILABLE: 'available',
  RESERVED:  'reserved',
  SOLD:      'sold',
  HOLD:      'hold',
  UNKNOWN:   'unknown',
}

/**
 * Sort priority for product status.
 * Lower number = earlier in ascending sort (available first, unknown last).
 */
export const STATUS_PRIORITY = {
  [AVAILABILITY_STATUS.AVAILABLE]: 1,
  [AVAILABILITY_STATUS.RESERVED]:  2,
  [AVAILABILITY_STATUS.SOLD]:      3,
  [AVAILABILITY_STATUS.HOLD]:      4,
  [AVAILABILITY_STATUS.UNKNOWN]:   5,
}
